import { VStack, HStack, Text, useTheme } from '@chakra-ui/react'

import { Blog } from '@/features/blogs/types/blog'
import { BlogItem } from '../BlogItem'

const SUGGESTION_BLOGS_LIMIT = 3

interface Props {
  blogs: Blog[]
}

function SuggestionBlogs({ blogs }: Props): React.ReactElement {
  const theme = useTheme()

  return (
    <VStack mt={4}>
      <Text
        as="h2"
        sx={{
          width: '100%',
          fontSize: '4xl',
          fontWeight: 500,
          color: theme.colors.primary[500],
          marginTop: 3,
          marginBottom: 5,
        }}
      >
        บทความที่เกี่ยวข้อง
      </Text>
      <HStack w={'100%'} sx={{ alignItems: 'flex-start' }}>
        {blogs.slice(0, SUGGESTION_BLOGS_LIMIT).map((blog, idx) => (
          <BlogItem key={idx} data={blog} />
        ))}
      </HStack>
    </VStack>
  )
}

export default SuggestionBlogs
